import { cn, iaRa } from 'lib/helpers/utility';
import { sanitize } from 'lib/helpers/sanitize';

import DocText from 'components/shared/DocumentSheet/DocText';
import { DOC_TEXT } from 'components/shared/DocumentSheet/lib/docStyles';

const Line = ({ label, value, className, labelClass, valueClass }) => (
  <div className={cn('flex items-baseline justify-between gap-x-4', className)}>
    <DocText size="xs" className={cn('w-auto', labelClass)}>
      {label}
    </DocText>
    <DocText size="xs" className={cn('w-auto whitespace-nowrap tabular-nums', valueClass)}>
      {value}
    </DocText>
  </div>
);

const Aging = ({ aging }) => (
  <div className="mt-3">
    <DocText variant="label" size="small" className={DOC_TEXT.microLabel}>
      AGING BREAKDOWN · ACCOUNT (30-60-90)
    </DocText>
    <div className="mt-1 grid grid-cols-4 gap-2">
      {aging.buckets.map((bucket) => (
        <div key={bucket.key} className="text-right">
          <DocText size="xs" className={cn(DOC_TEXT.legend, 'whitespace-nowrap text-right')}>
            {bucket.label}
          </DocText>
          <DocText size="xs" className={cn(DOC_TEXT.cell, 'text-right tabular-nums')}>
            {bucket.value}
          </DocText>
        </div>
      ))}
    </div>
    <Line
      label="Total account balance"
      value={aging.total}
      className="mt-1.5 border-0 border-t border-solid border-neutral-300 pt-1"
      labelClass="text-[11px] font-700 leading-4 text-neutral-900"
      valueClass="text-[11px] font-700 leading-4 text-neutral-900"
    />
  </div>
);

const InvoiceDocBottom = ({ memo, disclaimer, aging, rows, footnote, amountDue, dueDate }) => (
  <div className="mt-[14px] flex items-start justify-between gap-x-6 xs:flex-col xs:gap-y-5">
    <div className="min-w-0 flex-1">
      {memo && (
        <div>
          <DocText variant="label" size="small" className={DOC_TEXT.microLabel}>
            MEMO
          </DocText>
          <div
            className={cn(
              DOC_TEXT.meta,
              'mt-0.5 break-words [&_ol]:list-decimal [&_ol]:pl-4 [&_p]:m-0 [&_ul]:list-disc [&_ul]:pl-4'
            )}
            dangerouslySetInnerHTML={sanitize(memo)}
          />
        </div>
      )}
      {disclaimer && (
        <DocText size="xs" className={cn(DOC_TEXT.legend, memo ? 'mt-2' : '')}>
          {disclaimer}
        </DocText>
      )}
      {aging && <Aging aging={aging} />}
    </div>
    <div className="w-[348px] shrink-0 xs:w-full">
      {iaRa(rows).map((row, index) =>
        row.muted ? (
          <Line
            key={`${row.label}-${index}`}
            label={row.label}
            value={row.value}
            className="py-0.5 pl-3"
            labelClass={DOC_TEXT.summarySub}
            valueClass={DOC_TEXT.summarySub}
          />
        ) : (
          <Line
            key={`${row.label}-${index}`}
            label={row.label}
            value={row.value}
            className="py-1"
            labelClass={DOC_TEXT.summaryRow}
            valueClass={DOC_TEXT.summaryRow}
          />
        )
      )}
      <Line
        label={dueDate ? `Amount due · ${dueDate}` : 'Amount due'}
        value={amountDue}
        className="mt-1.5 border-0 border-t-2 border-solid border-neutral-900 pt-2"
        labelClass={DOC_TEXT.summaryGrand}
        valueClass={DOC_TEXT.summaryGrand}
      />
      {footnote && (
        <Line
          label={footnote.label}
          value={footnote.value}
          className="pt-1.5"
          labelClass={DOC_TEXT.summarySub}
          valueClass={DOC_TEXT.summarySub}
        />
      )}
    </div>
  </div>
);

export default InvoiceDocBottom;
